import { ReactComponent } from "/builds/mb/front/src/app/assets/images/menuBurger.svg?react";
import url from "/builds/mb/front/src/app/assets/images/menuBurger.svg?url";
export { ReactComponent };
export default url;
